<template lang="pug">
.PopupWorkspace
  .PopupWorkspace-header
    h2 Создание рабочего пространства

  .PopupWorkspace-body.ServiceParams
    .ServiceParams-spinner
      fade-loader.Spinner(
        :loading='isLoading',
        color='#27bd8a',
        height='8px',
        width='3px',
        radius='10px'
      )

    .ServiceParams-fields(v-if='!isLoading')
      div(v-for='field in formFields')
        .ServiceField(v-if='field.isVisible')
          .ServiceField-label(v-if='field.type !== "bool" && field.type !== "checkbox"') {{ field.label }}
          template(v-if='field.type === "list"')
            .ListItem(v-for='(listItem, listItemIndex) in field.value')
              .ListItem-period {{ periodsDates[listItemIndex].name }}
              .ListItem-field
                input.TextInput.TextInput--block(
                  :id='idPrefix + field.name',
                  type='number',
                  v-model='field.value[listItemIndex]'
                )
          switcher(
            v-if='field.type === "bool" || field.type === "checkbox"',
            :id='idPrefix + field.name',
            @toggle='updateLinkedFields()',
            v-model='field.value'
          ) {{ field.label }}
          period-interval(
            v-if='field.type === "period"',
            :id='idPrefix + field.name',
            :initialSelection='field.value',
            @select='updatePeriod(field, $event)'
          )
          input.TextInput.TextInput--block(
            type='text',
            :id='idPrefix + field.name',
            v-if='field.type === "str"',
            v-model='field.value'
          )
          .FileInput.FileInput--block(
            v-if='fileTypes.indexOf(field.type) > -1',
            :id='idPrefix + field.name',
            @dragover='dragoverprevent',
            @drop.prevent='addFile($event, field)'
          )
            label(v-if='!field.url') {{ field.filename || "Выберите файл" }}
              input.TextInput.TextInput--block(
                type='file',
                @input='changeFile(field, $event)'
              )
            .FileInput-file(v-else)
              a.OneLine(
                @click='getFile($event, field.url)',
                href='#'
              ) {{ field.name }}
              i.Icon.IconClose.Pointer(@click='removeUrl(field)')
          input.TextInput(
            v-if='field.type === "int"',
            :id='idPrefix + field.name',
            type='number',
            v-model='field.value'
          )
          .ServiceField(
            v-if='field.type === "adm_levels"',
            v-for='level in field.value'
          )
            switcher(
              v-model='level.isSelected',
              :id='idPrefix + field.name'
            ) {{ level.name }}
          .Select(v-if='field.type === "select"')
            custom-select(
              :id='idPrefix + field.name',
              placeholder='Выберите значение из списка',
              :isBoldSelected='true',
              :optionsIdPrefix='idPrefix + field.name + "_"',
              @input='field.value = $event',
              :options='field.select',
              :value='field.value'
            )
          input-notification(v-for='error in field.errors', :key="error") {{ fieldErrors[error] }}
      .ServiceField(v-if='!isLoading && !canCalculate')
        input-notification Превышены системные лимиты
    .ServiceParams-limits
      limits(
        :isRight='true',
        :isTop='true',
        :id='idPrefix + "limits"'
      )
  .PopupWorkspace-footer(v-if='!isLoading')
    button.Btn.Btn--blue(
      @click='startCurrent',
      :disabled='!canCalculate || isCreating',
      :id='idPrefix + "create"'
    ) Создать новое рабочее пространство
    button.Btn.Btn--grey(
      @click='cancel',
      :id='idPrefix + "cancel"'
    ) Отмена
</template>

<script>
import Switcher from '@/components/Switcher.vue'
import PeriodInterval from '@/components/PeriodInterval'
import Log from '@/components/modeling/Log.vue'
import periods from '@/mixins/periods'
import CustomSelect from '@/components/CustomSelect'
import FadeLoader from 'vue-spinner/src/FadeLoader'
import Limits from '@/components/modeling/Limits'
import limits from '@/mixins/limits'
import serviceparameters from '@/mixins/serviceparameters'

export default {
  name: 'init-workspace',
  mixins: [periods, limits, serviceparameters],
  components: {
    PeriodInterval,
    Switcher,
    CustomSelect,
    Log,
    Limits,
    FadeLoader,
    'input-notification': () => import('@/components/InputNotification')
  },
  computed: {
    workspaceList() {
      return this.$store.getters.activeWorkspaceList
    },
    workspace() {
      return this.$store.getters.workspace
    },
    version() {
      return this.$store.getters.version
    },
    admLevels() {
      return this.$store.getters.settings.administrative_levels ? this.$store.getters.settings.administrative_levels.filter((v) => v.adm_level !== 20) : []
    }
  },
  data() {
    return {
      selectedServiceDetails: [],
      log: [],
      idPrefix: 'InitWorkspacePopup_',
      error: [],
      selectedService: { id: 'workspace' },
      isCreating: false
    }
  },
  methods: {
    cancel() {
      this.$ui.popup.ok()
    },
    getParams() {
      this.isLoading = true
      this.$store
        .dispatch('getModelingInitWorkspaceDetails')
        .then((r) => {
          this.selectedServiceDetails = r[0].params || []
          this.log = r[0].log || []
          this.error = r[0].error || []
        })
        .catch((e) => {
          this.$store.commit('setApiErrorInfo', 'Ошибка получения списка параметров')
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    createWorkspace() {
      const params = {}
      const requestParams = this.generateRequestParams('name')
      if (!requestParams) {
        this.$ui.toast.show({
          text: 'Форма ввода параметров содержит ошибки. Устраните их и повторите попытку формирования нового рабочего пространства.',
          type: 'error'
        })
        return
      }

      this.isCreating = true
      this.$store
        .dispatch('modelingInitWorkspace', requestParams)
        .then((v) => {
          this.isCreating = false
          this.$ui.toast.show({ text: 'Начат процесс создания рабочего пространства', type: 'success' })
          if (this.workspaceList.length > 0) {
            this.$ui.popup.ok()
          }
        })
        .catch((e) => {
          this.isCreating = false
          this.$store.commit('setApiErrorInfo', 'При запуске процесса создания рабочего пространства произошла ошибка')
        })
    },
    startCurrent() {
      this.$store.dispatch('getModelingLimits').then((r) => {
        this.canCalculate ? this.createWorkspace() : this.showCanCalculateNotification()
      })
    }
  }
}
</script>

<style lang="scss">
@import '~base';
.Popup .ServiceParams {
  --highlightBg: #{$grey12};
  --textError: #{$red};
}

.Popup[data-theme='dark'] .ServiceParams {
  --valueText: #{$grey1};
  --highlightBg: #{$grey12};
  --textError: #{$red};
}

.Popup .PopupWorkspace {
  --footerBorder: #{$grey3};
  --valueColor: #{$grey8};
  --textError: #{$red};
  --selectedBg: #{$grey7};
}

.Popup[data-theme='dark'] .PopupWorkspace {
  --footerBorder: #{$grey2};
  --textError: #{$red};
  --selectedBg: #{$grey7};
}
</style>
<style scoped lang="scss">
@import '~base';

.PopupWorkspace {
  position: relative;

  &-error {
    padding: 10px 20px;
    color: red;
    font-size: 14px;
    text-align: center;
  }

  &-header {
    padding: 25px 30px 15px;

    h2 {
      margin-bottom: 0;
      font-size: 16px;
      text-transform: uppercase;
    }
  }

  &-body {
    padding: 10px 30px 10px 30px;
  }

  &-footer {
    padding: 5px 30px 10px;
    border-top: 1px solid var(--footerBorder);

    .Btn {
      min-width: 155px;
      font-size: 11px;
      font-weight: 300;
      text-transform: uppercase;
    }

    .Btn + .Btn {
      margin-left: 12px;
    }
  }
}
.ServiceParams {
  position: relative;
  padding-bottom: 30px;
  font-size: 12px;

  &-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -16px 0 0 -16px;
  }

  &-limits {
    position: absolute;
    right: 30px;
    bottom: 40px;
    display: flex;
    justify-content: flex-end;
  }
}

.ServiceField {
  margin-bottom: 20px;

  & & {
    padding: 3px 10px;
    margin: 0;

    &:nth-child(2n + 1) {
      background: var(--highlightBg);
    }
  }

  &-error {
    color: var(--textError);
  }
}

.ListItem {
  display: flex;
  align-items: center;
  padding: 3px 10px;

  &-period {
    flex: 0 0 200px;
    width: 300px;
  }

  &-field {
    flex: 1 1 auto;
  }

  &:nth-child(2n + 1) {
    background: var(--highlightBg);
  }
}

.Select {
  height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/InitWorkspace.vue